(function () {
  document.documentElement.classList.add('fp-js');

  function initReveal() {
    var els = document.querySelectorAll('.fp-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('fp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('fp-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    // Dentro de un riel que se desliza de costado (videos, tarjetas) lo que está fuera de pantalla nunca
    // "entra" a la vista: esos se muestran directo, si no quedan invisibles en el celular.
    function enRielHorizontal(el) {
      for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
        var ox = getComputedStyle(p).overflowX;
        if (ox === 'auto' || ox === 'scroll') return true;
      }
      return false;
    }
    els.forEach(function (el) {
      if (enRielHorizontal(el)) el.classList.add('fp-visible'); else io.observe(el);
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-fp-sticky]');
    var anchor = document.querySelector('[data-fp-hero-btn]');
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('fp-show', !e.isIntersecting);
      });
    });
    io.observe(anchor);
  }

  function initFormularios() {
    // 12-oct (Método 3x3, pilar Conversión): "Agregar al carrito" abre el carrito lateral (barra 10 % 2.º producto,
    // "Completá tu rutina") en vez de saltar directo al checkout. Si el carrito lateral no está o falla, va a /cart.
    document.querySelectorAll('form[data-fp-form]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        var b = f.querySelector('button[type=submit]');
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || !window.fetch) { if (b) { setTimeout(function () { b.disabled = true; }, 0); } return; }
        e.preventDefault();
        if (b) b.disabled = true;
        var fd = new FormData(f);
        fd.delete('return_to');
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok || !res.j.sections) { window.location.href = '/cart'; return; }
            // Si la página cargó con el carrito vacío, <cart-drawer> tiene .is-empty y oculta los productos (igual que product-form.js de Dawn).
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.j);
            // El HTML nuevo del carrito trae animaciones de entrada (scroll-trigger, opacidad 0.01) que nadie dispara: las mostramos.
            setTimeout(function () {
              if (typeof window.initializeScrollAnimationTrigger === 'function') { try { window.initializeScrollAnimationTrigger(drawer.innerHTML); } catch (err) {} }
              drawer.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.remove('scroll-trigger', 'scroll-trigger--offscreen'); });
            }, 50);
            if (b) b.disabled = false;
          })
          .catch(function () { window.location.href = '/cart'; });
      });
    });
  }

  function initSliders() {
    document.querySelectorAll('[data-fp-slider]').forEach(function (root) {
      var slides = root.querySelectorAll('.fp-slide');
      var dots = root.querySelectorAll('.fp-dot');
      if (slides.length < 2) return;
      var i = 0;
      var ms = parseInt(root.getAttribute('data-speed') || '6', 10) * 1000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;
      function go(n) {
        slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
      }
      function play() { if (!reduce) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, ms); } }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', play);
      play();
    });
  }

  function initCarruseles() {
    document.querySelectorAll('[data-fp-carousel]').forEach(function (root) {
      var track = root.querySelector('.fp-prod-track');
      var bar = root.querySelector('.fp-progress span');
      var prev = root.querySelector('[data-fp-prev]');
      var next = root.querySelector('[data-fp-next]');
      if (!track) return;
      function update() {
        if (!bar) return;
        var max = track.scrollWidth - track.clientWidth;
        var vis = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(vis * 100, 10) + '%';
        bar.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - vis * 100) : 0) + '%';
      }
      function step(dir) {
        var card = track.querySelector('.fp-card');
        var w = card ? card.getBoundingClientRect().width + 24 : track.clientWidth;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // Testimonios en video: el reproductor de YouTube se carga recién al tocar la portada.
  function initReels() {
    document.querySelectorAll('[data-fp-yt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-fp-yt');
        if (!id || b.classList.contains('is-playing')) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        f.title = b.querySelector('strong') ? b.querySelector('strong').textContent : 'Testimonio';
        b.appendChild(f);
        b.classList.add('is-playing');
      });
    });
  }

  // Selector de sabor/variante: actualiza todos los formularios de compra de la página.
  function initVariantes() {
    document.querySelectorAll('[data-fp-variantes]').forEach(function (fs) {
      fs.addEventListener('change', function (e) {
        if (!e.target || e.target.name !== 'fp-variante') return;
        document.querySelectorAll('form[data-fp-form] input[name="id"]').forEach(function (i) { i.value = e.target.value; });
        document.querySelectorAll('[data-fp-var-img]').forEach(function (img) {
          try { var m = JSON.parse(img.getAttribute('data-imgs')); if (m[e.target.value]) img.src = m[e.target.value]; } catch (err) {}
        });
      });
    });
  }

  // Producto sugerido del carrito (snippets/fp-cart-extra): agrega con un toque y redibuja el cajón sin recargar.
  function initSugerido() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-fp-sug]');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-cargando');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-fp-sug')), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
      }).then(function (r) { return r.json(); }).then(function (res) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && res.sections) drawer.renderContents(res);
        else window.location.href = '/cart';
      }).catch(function () { window.location.href = '/cart'; });
    });
  }

  function start() { initReveal(); initSticky(); initFormularios(); initSliders(); initCarruseles(); initReels(); initVariantes(); initSugerido(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
